import request from "@/util/request";

export function Course_GetList(params) {
  return request({
    url: "/pc/Course/Course_GetList",
    method: "get",
    params,
  });
}

export function Material_GetList(params) {
  return request({
    url: "/pc/Material/Material_GetList",
    method: "get",
    params,
  });
}
export function Exercise_GetList(params) {
  return request({
    url: "/pc/QBank/Exercise_GetList",
    method: "get",
    params,
  });
}
export function Enroll_GetList(params) {
  return request({
    url: "/pc/Enroll/Enroll_GetList",
    method: "get",
    params,
  });
}
export function Teacher_GetList(params) {
  return request({
    url: "/pc/Teacher/Teacher_GetList",
    method: "get",
    params,
  });
}
